import { createTheme } from '@mui/material/styles';

const turquoiseTheme = createTheme({
  palette: {
    primary: {
      main: '#2A9D8F',
      light: '#4DB8AB',
      dark: '#1E7A6F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#264653',
      light: '#3D6472',
      dark: '#1A3040',
      contrastText: '#ffffff',
    },
    background: {
      default: '#FAFAF8',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#264653',
      secondary: '#5A7A7A',
    },
    divider: '#E9E5DF',
  },
  typography: {
    fontFamily: '"Noto Sans JP", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 400,
      letterSpacing: '0.08em',
      lineHeight: 1.7,
    },
    h2: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 400,
      letterSpacing: '0.06em',
      lineHeight: 1.6,
    },
    h3: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 400,
      letterSpacing: '0.05em',
      lineHeight: 1.6,
    },
    h4: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 500,
      letterSpacing: '0.04em',
    },
    h5: {
      fontWeight: 500,
      letterSpacing: '0.04em',
    },
    h6: {
      fontWeight: 500,
      letterSpacing: '0.04em',
    },
    body1: {
      fontSize: '0.9375rem',
      lineHeight: 2,
      letterSpacing: '0.04em',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.9,
      letterSpacing: '0.04em',
    },
    button: {
      letterSpacing: '0.1em',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 2,
          padding: '12px 32px',
          fontSize: '0.875rem',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#238B7E',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
  },
});

export default turquoiseTheme;
